// @ts-nocheck

export default {
  VIEW_META_SET: 'VIEW_META_SET',
  VIEW_ITEMS_SET: 'VIEW_ITEMS_SET',
  RESOURCE_VIEWS_SET: 'RESOURCE_VIEWS_SET',
};